import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [],
  status: "idle",
  error: null,
};

export const activeUsersSlice = createSlice({
  name: "activeUsers",
  initialState,
  reducers: {
    activeUsersRequested: (state) => {
      state.status = "loading";
    },
    activeUsersRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    activeUsersRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.users = action.payload;
    },
  },
});

export const {
  activeUsersRequested,
  activeUsersRequestFailed,
  activeUsersRequestSucceeded,
} = activeUsersSlice.actions;

export default activeUsersSlice.reducer;
